import { createSelector } from 'reselect';
import { ArmyListUnit } from '@Models';
import { Export } from './view/export';
import {
  getArmy,
  getArmyList,
  getArmyListUnits,
  getState,
} from './exportSelector';
import { exportToClipboard } from '@Selectors/builder/myArmyList/export/exportToClipboard';

export const displayExportTxtWarhall = createSelector(
  [getState, getArmy, getArmyList, getArmyListUnits],
  (state, army, armyList, armyListUnits): Export<ArmyListUnit> => {
    if (!army || !armyList) {
      return {
        name: ``,
        army: '',
        game: '',
        points: 0,
        armyListUnits: [],
        exportTxt: '',
      } satisfies Export<ArmyListUnit> as Export<ArmyListUnit>;
    }

    let units: ArmyListUnit[] = [];
    army.organisations?.forEach((organisation) => {
      armyListUnits
        .filter((item) => item.organisation_id == organisation.id)
        .sort((a, b) => a.position - b.position)
        .forEach((item) => units.push(item));
    });

    return {
      name: '',
      army: army.name,
      points: armyList.points,
      armyListUnits: units,
      game: '',
      exportTxt: exportToClipboard(
        state,
        `“${armyList.creator}“ - ${armyList.name}`,
        army.name,
        units,
        `${armyList.points}`,
      ),
    } satisfies Export<ArmyListUnit> as Export<ArmyListUnit>;
  },
);
